import * as ngCore from '@angular/core'
import { Range } from '@attain-apps/range'
import { TypeChecker } from '@attain-apps/type-guards'

import * as tag from '../../../../tag'
import * as models from '../../models'
import * as pipes from '../../pipes'
import { Store } from '../../store'
import { ListStore } from '../store'
/** TODO */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [pipes.FormattedDateRangePipe, tag.Component],
  selector: 'atn-ds-date-multi-range-header',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ListStore} */
  public readonly listStore = ngCore.inject(ListStore)

  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  constructor() {
    ngCore.effect(() => {
      /**
       * Sync the local store with the selected range from the list:
       * Whenever the selected range in the list changes, update the local store's
       * `editingDateRange` to reflect the new selection.
       * This ensures the local state stays consistent with the external list state.
       */
      const listSelection = this.listStore.selectedRangeSg()
      const editingDateRange = listSelection
        ? models.DateRange.generate({
            end: listSelection.end,
            start: listSelection.start,
          })
        : undefined
      this.store.patchState({
        editingDateRange,
      })
    })

    /**
     * Propagate changes made to the `editingDateRange` back to the corresponding range in the list.
     */
    ngCore.effect(() => {
      const selectedRangeIndex = this.listStore.selectedRangeIndexSg()
      if (TypeChecker.isNullish(selectedRangeIndex)) {
        return
      }

      const editingDateRange = this.store.editingDateRangeSg()
      const editingRanges = this.listStore.editingRangesSg()

      const updatedRanges = [...editingRanges]
      updatedRanges[selectedRangeIndex] = new Range<Date>({
        end: editingDateRange.end ?? undefined,
        start: editingDateRange.start ?? undefined,
      })

      this.listStore.patchState({
        editingRanges: updatedRanges,
      })
    })
  }

  /**
   * Handles the selection of a date range.
   * Updates the list store with the index of the selected range.
   */
  public dateRangeSelectHandler(selectedRangeIndex: number) {
    this.listStore.patchState({
      selectedRangeIndex,
    })
  }

  /** Handles add button click event */
  public addRangeClickHandler() {
    this.listStore.addRange()
  }

  /** Handles delete button click event  */
  public deleteRangeClickHandler() {
    this.listStore.deleteRange({ current: true })
  }
}
